import script from "./SobreHome.vue?vue&type=script&setup=true&lang=js"
export * from "./SobreHome.vue?vue&type=script&setup=true&lang=js"

import "./SobreHome.vue?vue&type=style&index=0&id=40a3ee54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40a3ee54"]])

export default __exports__